import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import DashboardLayout from './components/dashboard/DashboardLayout';
import Dashboard from './components/dashboard/Dashboard';
import Users from './components/users/Users';
import ChatHistory from './components/chat/ChatHistory';
import KnowledgeBase from './components/knowledgebase/KnowledgeBase';
import Agent from './components/agent/Agent';
import SignInPage from './components/auth/SignIn';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Customers from './components/customers/Customers';
import Cars from './components/cars/Cars';
import Deals from './components/deals/Deals';
import Reporting from './components/reporting/Reporting';
import CustomerDetail from './components/reporting/CustomerDetail';
import Showrooms from './components/showroom/Showrooms';
import UserShowroom from './components/showroom/UserShowroom';
import DailyLedger from './components/dailyLedger/DailyLedger';
import AccountSettings from './components/auth/AccountSettings';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/sign-in" element={<SignInPage />} />
          
          {/* Protected routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            {/* superAdmin and admin can access Users */}
            <Route path="users" element={
              <ProtectedRoute requireAdmin={true}>
                <Users />
              </ProtectedRoute>
            } />
            {/* Only superAdmin can access Showrooms */}
            <Route path="showrooms" element={
              <ProtectedRoute requireSuperAdmin={true}>
                <Showrooms />
              </ProtectedRoute>
            } />
            {/* admin and user can access business functionality */}
            <Route path="customers" element={<Customers />} />
            <Route path="cars" element={<Cars />} />
            <Route path="deals" element={<Deals />} />
            <Route path="daily-ledger" element={<DailyLedger />} />
            <Route path="reporting" element={<Reporting />} />
            <Route path="reporting/customer/:customerId" element={<CustomerDetail />} />
            {/* Only admin can access My Showroom */}
            <Route path="my-showroom" element={
              <ProtectedRoute requireAdmin={true}>
                <UserShowroom />
              </ProtectedRoute>
            } />
            <Route path="account" element={<AccountSettings />} />
            <Route path="/chat-history" element={<ChatHistory />} />
            {/* <Route path="/credits" element={<Credits />} /> */}
            <Route path="/knowledge-base" element={<KnowledgeBase />} />
            <Route path="/agent" element={<Agent />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
